function readEnvVar(key, fallback) {
    const g = globalThis;
    if (typeof g.Deno !== 'undefined' && typeof g.Deno.env?.get === 'function') {
        return g.Deno.env.get(key) ?? fallback;
    }
    return g.process?.env?.[key] ?? fallback;
}
export var LogLevel;
(function (LogLevel) {
    LogLevel["DEBUG"] = "debug";
    LogLevel["INFO"] = "info";
    LogLevel["WARN"] = "warn";
    LogLevel["ERROR"] = "error";
})(LogLevel || (LogLevel = {}));
class Logger {
    environment;
    service;
    constructor(environment = 'development', service = 'musedrops-backend') {
        this.environment = environment;
        this.service = service;
    }
    createLogEntry(level, message, context) {
        const entry = {
            timestamp: new Date().toISOString(),
            level,
            message,
            environment: this.environment,
            service: this.service,
        };
        if (context) {
            entry.context = context;
        }
        return entry;
    }
    output(entry) {
        if (this.environment === 'development') {
            const contextStr = entry.context ? ` ${JSON.stringify(entry.context)}` : '';
            const logMethod = entry.level === LogLevel.ERROR ? console.error :
                entry.level === LogLevel.WARN ? console.warn :
                    console.log;
            logMethod(`[${entry.level.toUpperCase()}] ${entry.message}${contextStr}`);
        }
        else {
            console.log(JSON.stringify(entry));
        }
    }
    debug(message, context) {
        this.output(this.createLogEntry(LogLevel.DEBUG, message, context));
    }
    info(message, context) {
        this.output(this.createLogEntry(LogLevel.INFO, message, context));
    }
    warn(message, context) {
        this.output(this.createLogEntry(LogLevel.WARN, message, context));
    }
    error(message, context) {
        this.output(this.createLogEntry(LogLevel.ERROR, message, context));
    }
}
export const logger = new Logger(readEnvVar('ENV', 'development'), readEnvVar('SERVICE_NAME', 'musedrops-backend'));
export default logger;
//# sourceMappingURL=logger.js.map